// Drag and drop on the Budget tab: the pure part (no DOM), so tests can check it.

/** A place a dragged row can go: a gap before row `slot` of a list, at page height `y`. */
export interface Slot {
  /** The group (for a category) or '' (for groups). */
  groupId: string;
  slot: number;
  y: number;
  left: number;
  width: number;
}

/** The slot nearest to a page height. */
export function nearestSlot(slots: Slot[], y: number): Slot | null {
  let best: Slot | null = null;
  for (const s of slots) if (!best || Math.abs(s.y - y) < Math.abs(best.y - y)) best = s;
  return best;
}

/**
 * The index the moved row ends up at, given the gap it was dropped in. In its own list, a gap
 * below it counts one less (it leaves its old place first). null: dropped where it already is.
 */
export function targetIndex(fromGroup: string, fromIndex: number, to: Pick<Slot, 'groupId' | 'slot'>): number | null {
  if (to.groupId !== fromGroup) return to.slot;
  const index = to.slot > fromIndex ? to.slot - 1 : to.slot;
  return index === fromIndex ? null : index;
}

/** A category may be dropped only into a group of its own kind. */
export const canDrop = (fromKind: string, toKind: string) => fromKind === toKind;
